import { NgModule, inject} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatRadioModule} from '@angular/material/radio';
import {MatDialogModule} from '@angular/material/dialog';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import {MatSelectModule} from '@angular/material/select';
import {MatOptionModule} from '@angular/material/core';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {NgxMatTimepickerModule, NgxMatTimepickerLocaleService} from 'ngx-mat-timepicker';
import {MatChipsModule} from '@angular/material/chips';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

import * as moment from 'moment';
import { registerLocaleData } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import {DateAdapter, MAT_DATE_LOCALE} from "@angular/material/core";
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from "@angular/material-moment-adapter";
import {CommonTokenStorage} from "../services/common-token-storage.service";
import { InjectionToken } from '@angular/core';
import {MAT_DATE_FORMATS} from "@angular/material/core";

import {
  MAT_COLOR_FORMATS,
  NgxMatColorPickerModule,
  NGX_MAT_COLOR_FORMATS
} from '@angular-material-components/color-picker';
import {NgxMatDatetimePickerModule, NgxMatNativeDateModule} from '@angular-material-components/datetime-picker';

import {CommonGeneralConfigService} from "../services/common-general-config.service";

//TODO: Uncomment the code below to enable Arabic labels for the date if needed. There is an issue with the translated picker in the datetime picker.
// import localeAr from '@angular/common/locales/ar';
// import localeEn from '@angular/common/locales/en';
// registerLocaleData(localeAr, 'ar');
// registerLocaleData(localeEn, 'en');

const FOO_DATEPICKER_CONFIG = new InjectionToken<string>('fooDatepickerConfig', {
  providedIn: 'root',
  factory: () => 'FooDatepickerConfig',
});

function getMatDateFormats(generalConfigService: CommonGeneralConfigService, configProperty: string) {
  const defaultFormat = {
    dateInput: configProperty === 'FooDatetimepickerConfig' ? 'DD-MM-YYYY HH:mm' : 'DD-MM-YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MM YYYY',
  };

  const format = generalConfigService.getConfigProperty(configProperty) || {};

  const mergeFormat = (key: string) => format[key] ?? defaultFormat[key];

  return {
    parse: {
      dateInput: mergeFormat('dateInput'),
    },
    display: {
      dateInput: mergeFormat('dateInput'),
      monthYearLabel: mergeFormat('monthYearLabel'),
      dateA11yLabel: mergeFormat('dateA11yLabel'),
      monthYearA11yLabel: mergeFormat('monthYearA11yLabel'),
    },
  };
}

@NgModule({
  declarations: [],
  imports: [
    NgbModule,
    NgSelectModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatRadioModule,
    NgxPaginationModule,
    MatDialogModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatOptionModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    NgxMatDatetimePickerModule,
    NgxMatColorPickerModule,
    MatChipsModule,
    MatTooltipModule,
    MatButtonModule,
  ],
  exports: [
    NgbModule,
    NgSelectModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatAutocompleteModule,
    MatRadioModule,
    NgxPaginationModule,
    MatDialogModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatOptionModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    NgxMatDatetimePickerModule,
    NgxMatColorPickerModule,
    MatChipsModule,
    MatTooltipModule,
    MatButtonModule,
  ],
  providers: [
    {provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS},
    {
      provide: MAT_DATE_FORMATS,
      useFactory: getMatDateFormats,
      deps: [CommonGeneralConfigService, FOO_DATEPICKER_CONFIG],
    },
    //TODO: Uncomment the code below to enable Arabic labels for the date if needed. There is an issue with the translated picker in the datetime picker.
    // {
    //   provide: LOCALE_ID,
    //   useFactory: (tokenStorage: CommonTokenStorage) => {
    //     return tokenStorage.getCurrentLanguage() || 'en';
    //   },
    //   deps: [CommonTokenStorage]
    // },
    // {
    //   provide: MAT_DATE_LOCALE,
    //   useFactory: (tokenStorage: CommonTokenStorage) => {
    //     return tokenStorage.getCurrentLanguage() || 'en';
    //   },
    //   deps: [CommonTokenStorage]
    // },
    // {
    //   provide: DateAdapter,
    //   useClass: MomentDateAdapter,
    //   deps: [MAT_DATE_LOCALE],
    //   useFactory: (locale: string) => {
    //     const adapter = new MomentDateAdapter(locale);
    //     moment.locale(locale);
    //     if(locale == 'ar') {
    //       NgxMatTimepickerModule.setLocale(locale);
    //     }
    //     // Ensure selected date is always returned in English format
    //     const originalFormat = adapter.format.bind(adapter);
    //     adapter.format = (date: moment.Moment, displayFormat: string, applyAppLocale: boolean = false) => {
    //       if (applyAppLocale) {
    //         return originalFormat(date, displayFormat);
    //       }
    //       return originalFormat(date.locale('en'), displayFormat);
    //     };
    //
    //     return adapter;
    //   }
    // },
    // {
    //   provide: NgxMatTimepickerLocaleService,
    //   useFactory: (tokenStorage: CommonTokenStorage) => {
    //     const curLang = tokenStorage.getCurrentLanguage() || 'en';
    //     let service = new NgxMatTimepickerLocaleService(curLang);
    //     service.updateLocale(curLang);
    //
    //     if(curLang == 'ar') {
    //       NgxMatTimepickerModule.setLocale(curLang);
    //       moment.locale('en');
    //     }
    //     return service;
    //   },
    //   deps: [CommonTokenStorage]
    // }
  ]
})
export class MaterialModule {
}
